// simplifies chart initiation to one call
import render from './_render'
import opts from './_opts'
import ref from './_state'
import createDom from './create-dom'

export default function (obj) {

    console.log(obj)

    const THED3 = window.THED3 || {}
    const d3 = d3 || window.d3
    const _ = _ || window._

    // merge opts with user values
    let mergedOpts = _.merge({}, opts, obj.config.charts)

    // have updated options
    ref.opts = mergedOpts

    // create a selection
    ref.dom  = d3.select(obj.bindto).append('div')
        // ensure chart has required classes
        .attr('class', obj.config.classes)

    // pass in text for dom
    createDom(ref.dom, obj.config.labels)

    // initiate chart
    const chart = render(ref)
        .selection(obj.bindto)
        .dataUrl(obj.data)

    chart.render()
 
}